var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from '../base';
import { API } from '../api';
import { DatasetProvider } from '../dataset';
import { ModalProvider } from '../popup/modal';
import { CanvasProvider } from './canvas';
import { BoostProvider } from '../boost';
import { BrainBankErrorCode } from '../error-code';
import { TranslateService } from '@ngx-translate/core';
var RegionOfInterestProvider = /** @class */ (function (_super) {
    __extends(RegionOfInterestProvider, _super);
    function RegionOfInterestProvider(api, datasetProvider, modalProvider, canvasProvider, boostProvider, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.datasetProvider = datasetProvider;
        _this.modalProvider = modalProvider;
        _this.canvasProvider = canvasProvider;
        _this.boostProvider = boostProvider;
        _this.translate = translate;
        return _this;
    }
    RegionOfInterestProvider.prototype.saveAndConfirmRetrain = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var roi, dataset, confirmationResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        roi = this.canvasProvider.exportROI();
                        if (!roi) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.updateROI(datasetIdentifier, roi)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.datasetProvider.reloadDataset(datasetIdentifier, true)];
                    case 2:
                        _a.sent();
                        dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
                        if (!(dataset && dataset.hasPolygons())) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.presentConfirmationModal({
                                title: this.translate.instant('Retrain and Redeploy'),
                                message: this.translate.instant('You have defined and saved a Region of Interest for this Brain. In order for the Region of Interest to take effect you must Retrain the Brain. <strong>Before retraining, page through the images and make sure the ROI is big enough to encapsulate the subject in all images.</strong>'),
                                discardBtnText: this.translate.instant('Retrain Later'),
                                confirmBtnText: this.translate.instant('Retrain')
                            }, 'roi-save-and-retrain-modal')];
                    case 3:
                        confirmationResult = _a.sent();
                        if (!(confirmationResult && confirmationResult.shouldRetrain)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.retrain(datasetIdentifier, confirmationResult.sendEmail)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, true];
                    case 6:
                        e_1 = _a.sent();
                        throw e_1;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.confirmUnsavedChangesAndRetrain = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var dataset, roi, confirmationResult, roiData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
                        if (!dataset) {
                            return [2 /*return*/, false];
                        }
                        if (!!dataset.hasPolygons()) return [3 /*break*/, 2];
                        roi = this.canvasProvider.exportROI();
                        if (!roi) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.updateROI(datasetIdentifier, roi)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2: return [4 /*yield*/, this.presentConfirmationModal({
                            title: this.translate.instant('Unsaved Changes'),
                            message: this.translate.instant('There are unsaved changes to your Region of Interest. Would you like to save those changes? If so you will need to retrain the Brain. This may effect accuracy results.'),
                            discardBtnText: this.translate.instant('Discard Changes'),
                            confirmBtnText: this.translate.instant('Save & Retrain')
                        }, 'roi-confirm-changes')];
                    case 3:
                        confirmationResult = _a.sent();
                        if (!(confirmationResult && confirmationResult.shouldRetrain)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.saveAndRetrain(datasetIdentifier, confirmationResult)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 5:
                        if (!(confirmationResult && !confirmationResult.shouldRetrain)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.load(datasetIdentifier)];
                    case 6:
                        roiData = _a.sent();
                        if (!roiData) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.canvasProvider.drawROI(roiData)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this.canvasProvider.deleteROI()];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [4 /*yield*/, this.canvasProvider.markROIAsSaved()];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12: return [2 /*return*/, true];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.saveAndRetrain = function (datasetIdentifier, confirmationResult) {
        return __awaiter(this, void 0, void 0, function () {
            var roi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        roi = this.canvasProvider.exportROI();
                        if (!roi) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.updateROI(datasetIdentifier, roi)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.datasetProvider.reloadDataset(datasetIdentifier, true)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.retrain(datasetIdentifier, confirmationResult && confirmationResult.sendEmail)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.confirmDeleteAndRetrain = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var dataset, confirmationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
                        if (!dataset) {
                            return [2 /*return*/];
                        }
                        if (!dataset.hasPolygons()) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.presentConfirmationModal({
                                title: this.translate.instant('Delete and Retrain'),
                                message: this.translate.instant('Are you sure you want to delete the region of interest from this Brain? If so you will need to retrain the Brain. This may effect accuracy results.'),
                                discardBtnText: this.translate.instant('Cancel'),
                                confirmBtnText: this.translate.instant('Delete & Retrain')
                            }, 'roi-delete-and-retrain-modal')];
                    case 1:
                        confirmationResult = _a.sent();
                        if (!(confirmationResult && confirmationResult.shouldRetrain)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.deleteROI(datasetIdentifier)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.datasetProvider.reloadDataset(datasetIdentifier, true)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.retrain(datasetIdentifier, confirmationResult.sendEmail)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.deleteROI(datasetIdentifier)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.load = function (datasetIdentifier, denormalize) {
        if (denormalize === void 0) { denormalize = false; }
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("datasets/" + datasetIdentifier + "/rois?denormalize=" + denormalize)];
                    case 1:
                        result = _a.sent();
                        if (result && result.message && result.message.roi && result.message.roi.data) {
                            return [2 /*return*/, result.message.roi.data];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1.error && err_1.error.code == BrainBankErrorCode.RoiNotFound) {
                            return [2 /*return*/, null];
                        }
                        else {
                            throw err_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.deleteROI = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("datasets/" + datasetIdentifier + "/rois")];
                    case 1:
                        _a.sent();
                        this.canvasProvider.deleteROI();
                        this.canvasProvider.markROIAsSaved();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.updateROI = function (datasetIdentifier, points) {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/rois", {
                                data: points
                            })];
                    case 1:
                        result = _a.sent();
                        if (result && result.success && result.message && result.message.roi && result.message.roi.data) {
                            this.canvasProvider.markROIAsSaved();
                            return [2 /*return*/, result.message.roi.data];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.toRectangle = function (data) {
        var minX = null;
        var minY = null;
        var maxX = null;
        var maxY = null;
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var point = data_1[_i];
            if (minX == null || point[0] < minX) {
                minX = point[0];
            }
            if (maxX == null || point[0] > minX) {
                maxX = point[0];
            }
            if (minY == null || point[1] < minY) {
                minY = point[1];
            }
            if (maxY == null || point[1] > minY) {
                maxY = point[1];
            }
        }
        if (minX == null || minY == null || maxX == null || maxY == null) {
            throw new Error("Unable to create a rectangle from the given points: (" + minX + "," + minY + "),(" + maxX + "," + maxY + ")");
        }
        return {
            width: maxX - minX,
            height: maxY - minY,
            x: minX,
            y: minY
        };
    };
    RegionOfInterestProvider.prototype.retrain = function (datasetIdentifier, sendEmail) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.boostProvider.retrain(datasetIdentifier, sendEmail)];
                    case 1:
                        _a.sent();
                        this.boostProvider.showRetrainProgress(datasetIdentifier);
                        return [2 /*return*/];
                }
            });
        });
    };
    RegionOfInterestProvider.prototype.presentConfirmationModal = function (data, cssClass) {
        var _this = this;
        return new Promise(function (resolve) {
            var modal = _this.modalProvider.createModal('RoiConfirmChangesModal', data, {
                cssClass: cssClass
            });
            modal.onDidDismiss(function (result) {
                resolve(result);
            });
            modal.present();
        });
    };
    /**
     * Create a string representing SVG commands to create the region of interest's overlay (minus the cutout in the center).
     * @param roiData The normalized coordinates (in percentiles) of the ROI
     * @param width The width of the current image asset
     * @param height The height of the current image asset
     */
    RegionOfInterestProvider.prototype.buildRoiShape = function (roiData, width, height) {
        if (!roiData) {
            return '';
        }
        var _a = roiData.sort(function (pointL, pointR) {
            var xL = pointL[0], yL = pointL[1];
            var xR = pointR[0], yR = pointR[1];
            return xL - xR || yL - yR;
        }), topLeft = _a[0], topRight = _a[1], bottomLeft = _a[2], bottomRight = _a[3];
        return "M 0 0 L " + width + " 0 " + width + " " + height + " 0 " + height + "\n                        M " + width * topLeft[0] + " " + height * topLeft[1] + "\n                        L " + width * topRight[0] + " " + height * topRight[1] + "\n                        " + width * bottomRight[0] + " " + height * bottomRight[1] + "\n                        " + width * bottomLeft[0] + " " + height * bottomLeft[1] + "\n                        z";
    };
    /**
     * Create a string representing SVG commands to create the region of interest's border (i.e, the cutout in the center).
     * @param roiData The normalized coordinates (in percentiles) of the ROI
     * @param width The width of the current image asset
     * @param height The height of the current image asset
     */
    RegionOfInterestProvider.prototype.buildRoiBorder = function (roiData, width, height) {
        if (!roiData) {
            return '';
        }
        var _a = roiData.sort(function (pointL, pointR) {
            var xL = pointL[0], yL = pointL[1];
            var xR = pointR[0], yR = pointR[1];
            return xL - xR || yL - yR;
        }), topLeft = _a[0], topRight = _a[1], bottomLeft = _a[2], bottomRight = _a[3];
        return "M " + width * topLeft[0] + " " + height * topLeft[1] + "\n                L " + width * topRight[0] + " " + height * topRight[1] + "\n                " + width * bottomRight[0] + " " + height * bottomRight[1] + "\n                " + width * bottomLeft[0] + " " + height * bottomLeft[1] + "\n                z";
    };
    RegionOfInterestProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            DatasetProvider,
            ModalProvider,
            CanvasProvider,
            BoostProvider,
            TranslateService])
    ], RegionOfInterestProvider);
    return RegionOfInterestProvider;
}(BaseProvider));
export { RegionOfInterestProvider };
//# sourceMappingURL=region-of-interest.js.map


// WEBPACK FOOTER //
// ./src/providers/workspace/region-of-interest.ts.pre-build-optimizer.js